export default "__VITE_ASSET__DvWpVfgi__"